import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getGarmentInspectionImagesSingleQrCode } from "../../services/GarmentInspection/GarmentInspection";

const WareHouseGarmentInspectionImages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { QrCodeInfo,FROM_WHERE } = location.state || {}; // Fallback to prevent undefined errors


  const [tagInfo, setTagInfo] = useState([]);

  const fetchQrCode = (qrCodeId) => {
    getGarmentInspectionImagesSingleQrCode(qrCodeId)
      .then((response) => {
        if (!response.data.error) {
          const inspectionImagesData = response.data;
          setTagInfo(inspectionImagesData);
        }
      })
      .catch((err) => {
        console.error("Error fetching inspection images:", err);
      });
  };

  useEffect(() => {
    if (FROM_WHERE === "OBJECT") {
      fetchQrCode(QrCodeInfo?.qrCodeInfo.qrCodeId);
    } else {
      fetchQrCode(QrCodeInfo?.qrCodeId);
    }
  }, []);

  const renderTagInfoItem = () => {
    return tagInfo.map((item) => {
      const garmentName =
        FROM_WHERE === "OBJECT"
          ? QrCodeInfo?.qrCodeInfo?.garmentName
          : QrCodeInfo.garmentName;
      const qrCode =
        FROM_WHERE === "OBJECT"
          ? QrCodeInfo?.qrCodeInfo?.qrCode
          : QrCodeInfo.qrCode;
      const displayImages = item.tagImageUrl || [];
      return (
        <div className="col-6 p-4">
        {displayImages && (
            <div>
              
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginVertical: 10,
                  }}
                >
                  <img
                    src={displayImages}
                    style={{ width: 250, height: 250 }}
                  />
                </div>
              
            <p className="text-2xl font-medium text-center">
                {qrCode} - {garmentName?.replace(/_/g, " ")}
              </p>
            </div>
            )}
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate(-1)}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Garment Inspection
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        {tagInfo.length > 0 ? (
          <div className="grid m-2">{renderTagInfoItem()}</div>
        ) : (
          <div>
            <p className="text-3xl font-medium text-center">
              No Tag Image Found
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WareHouseGarmentInspectionImages;
